import { IListModelQueryParamValues, IListResponse, IModelJsonValues } from '@sparelabs/http-client-utils'

export enum CustomLinkType {
  WebUrl = 'webUrl',
  PhoneNumber = 'phoneNumber',
  EmailAddress = 'emailAddress',
}

// Request:
export interface ICustomLinkPostBody {
  type: CustomLinkType
  value: string
  name: string
}

export interface ICustomLinkPatchBody {
  value: string
  name: string
}

export interface ICustomLinkListQueryParams extends IListModelQueryParamValues {
  search?: string
}

// Response:

export interface ICustomLinkResponse extends IModelJsonValues {
  id: string
  type: CustomLinkType
  value: string
  name: string
}

export interface ICustomLinkListResponse extends IListResponse<ICustomLinkResponse> {}
